import { useEffect, useContext } from 'react';
import { AuthContext } from '../../logic';
import { checkLoginType } from '../../api';

const useLoginType = (): void => {
	const { setLoginType } = useContext(AuthContext);

	const onTypeInit = async () => {
		const type = await checkLoginType();
		setLoginType(type);
	};

	useEffect(() => {
		onTypeInit();
	}, []);
};

export { useLoginType };
